import React from 'react';
import PropTypes from 'prop-types';

import { useContextProperties } from 'contexts/properties';
import { useContextMatchParams } from 'contexts/matchParams';
import { useContextResultOrigin } from 'contexts/resultOrigin';

import { useContextCurrentSite } from 'contexts';
import { BarrasSimpleSumaBloques } from 'components/pactometroCheck/barrasSimpleSumaBloques';
import LoadingPlaceholder from 'components/loadingPlaceholder';

import useResultProvider from 'dataProvider/hooks/useResultProvider';
import { SUBTYPES, TYPES } from '../../envs';
import './sumaBloques.scss';

import { LOCALHOST, getSite } from '../../constants/sites';

import { MasterBar } from '../../components';

export const SumaBloques = () => {
  const { params } = useContextProperties();
  const { matchParams } = useContextMatchParams();

  const { year, type, electionNumber, placeId } = matchParams;

  const { currentSite } = useContextCurrentSite();

  const resultOrigin = useContextResultOrigin();

  const site = getSite();

  const { result: dataResult } = useResultProvider({
    electionPlace: placeId,
    active: resultOrigin?.primary?.active,
    year,
    type,
    subtype: type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
    electionNumber,
    placeId: type === TYPES.GENERAL ? 'C108' : placeId,
    site: site !== LOCALHOST ? site : currentSite
  });

  const selectedComponent = params.sites[
    site === LOCALHOST ? currentSite : site
  ].generator.tabs[type].commons.find(c => c.component === 'MINI');

  const getSeatsAndAcronyms = (data, selectedRight, selectedLeft) => {
    const initialValue = {
      partiesRight: { text: '', seats: 0, parties: [] },
      partiesLeft: { text: '', seats: 0, parties: [] }
    };
    if (data) {
      return data.reduce((acc, party) => {
        if (party.seats > 0) {
          // Seleccionamos el campo que vamos a modificar
          // eslint-disable-next-line no-nested-ternary
          const field = selectedRight.includes(party.id)
            ? 'partiesRight'
            : selectedLeft.includes(party.id)
            ? 'partiesLeft'
            : null;

          if (!field) {
            return acc;
          }
          // Acumulamos tanto texto como seats como los parties
          acc[field].text = acc[field].text.length
            ? `${acc[field].text} + ${party.partyAcronym}`
            : party.partyAcronym;
          acc[field].seats += party.seats;
          acc[field].parties = [...acc[field].parties, party];
        }
        return acc;
      }, initialValue);
    }
    return initialValue;
  };

  if (
    !params ||
    !selectedComponent ||
    !selectedComponent.data ||
    Object.keys(dataResult).length === 0
  ) {
    return <LoadingPlaceholder />;
  }
  return (
    <>
      <MasterBar
        optionalTitleRegular={
          params.sites[site === LOCALHOST ? currentSite : site].labels.bloques
        }
        optionalTitleStrong={
          params.sites[site === LOCALHOST ? currentSite : site].labels
            .bloques_strong
        }
        isOpenedTabs={false}
      />
      <div className="SCSumaBloquesDato">
        <div className="SCSumaBloquesMain">
          <div className="SCSumaBloquesSection">
            <div className="sumaBloques-caras">
              <ul className="sumaBloques-caras-list sumaBloques-caras-list--left">
                <li className="sumaBloques-caras-item">
                  <img
                    className="sumaBloques-caras-img sumaBloques-caras-img--psoe"
                    src="https://statics.atresmedia.com/elecciones/assets/persons/sanchez.png"
                    alt="Pedro Sánchez"
                  />
                </li>
                <li className="sumaBloques-caras-item">
                  <img
                    className="sumaBloques-caras-img sumaBloques-caras-img--sumar"
                    src="https://statics.atresmedia.com/elecciones/assets/persons/Diaz.png"
                    alt="Yolanda Díaz"
                  />
                </li>
              </ul>
              <ul className="sumaBloques-caras-list sumaBloques-caras-right">
                <li className="sumaBloques-caras-item">
                  <img
                    className="sumaBloques-caras-img sumaBloques-caras-img--vox"
                    src="https://statics.atresmedia.com/elecciones/assets/persons/abascal.png"
                    alt="Santiago Abascal"
                  />
                </li>
                <li className="sumaBloques-caras-item">
                  <img
                    className="sumaBloques-caras-img sumaBloques-caras-img--pp"
                    src="https://statics.atresmedia.com/elecciones/assets/persons/feijoo.png"
                    alt="Alberto Núñez Feijóo"
                  />
                </li>
              </ul>
            </div>
            {selectedComponent.data.blocks.map(block => {
              const { partiesRight, partiesLeft } = getSeatsAndAcronyms(
                dataResult.partiesResult?.sort(
                  (a, b) => a.votesPercent > b.votesPercent
                ),
                block.selectedsRight,
                block.selectedsLeft
              );

              const includedColor = partiesRight.parties.map(i => ({
                ...i,
                partyColor: i.partyColor || block.right
              }));
              const excludedColor = partiesLeft.parties.map(i => ({
                ...i,
                partyColor: i.partyColor || block.left
              }));

              return (
                <BarrasSimpleSumaBloques
                  height={45}
                  data={[...excludedColor, ...includedColor]}
                  selectedsLeft={
                    block.selectedsLeft.length > 0 ? block.selectedsLeft : []
                  }
                  selectedsRight={
                    block.selectedsRight.length > 0 ? block.selectedsRight : []
                  }
                  totalSeat={dataResult.totalSeats}
                  centerProps={{ position: 'down', lineStyle: 'solid' }}
                  title={
                    block.selectedsLeft.length > 0 && (
                      <div className="SCSumaBloquesDatos">
                        <div className="SCSumaBloquesDato">
                          <p className="big">{partiesLeft.seats} </p>
                          <p className="sumaBloques-partidos">
                            {block.excludeText || partiesLeft.text}
                          </p>
                        </div>
                        <div className="SCSumaBloquesDato right">
                          <p className="big">{partiesRight.seats} </p>
                          <p className="sumaBloques-partidos">
                            {block.includeText || partiesRight.text}
                          </p>
                        </div>{' '}
                      </div>
                    )
                  }
                />
              );
            })}
          </div>
          <p className="sumaBloques-leyenda">
            * El bloque central en gris incluye Teruel Existe
          </p>
        </div>
      </div>
    </>
  );
};

SumaBloques.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      year: PropTypes.string,
      type: PropTypes.string,
      electionNumber: PropTypes.string,
      placeId: PropTypes.string
    })
  })
};

SumaBloques.defaultProps = {
  match: {
    params: {
      year: '',
      type: '',
      electionNumber: '',
      placeId: ''
    }
  }
};
